var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRentIconDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rent-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.038,
    height: 76.8,
    viewBox: "0 0 86.038 76.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M65.1,41.7a1.2,1.2,0,1,0-1.2-1.2,1.1,1.1,0,0,0,1.2,1.2Z",
    transform: "translate(2.819 -2.1)",
    fill: "#231f20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(2.819 -2.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M82.6,78.9a.576.576,0,0,1-.6-.6V3.4H38.3V78.3a.576.576,0,0,1-.6.6c-.3,0-.7-.3-.7-.6V2.7a.576.576,0,0,1,.6-.6h45a.576.576,0,0,1,.6.6V78.2A.563.563,0,0,1,82.6,78.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M42,77.2a.6.6,0,0,1-.4-.1c-.2-.1-.2-.3-.2-.5V6.1a.764.764,0,0,1,.2-.5.6.6,0,0,1,.4-.1h.2l27.4,6.8a.634.634,0,0,1,.5.6V70.1a.56.56,0,0,1-.5.6L42.2,77.1C42.1,77.2,42.1,77.2,42,77.2Zm.7-1.5,26.1-6.1V13.5L42.7,7Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(2.819 -2.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M15.4,24.8a6.7,6.7,0,1,1,6.7-6.7A6.7,6.7,0,0,1,15.4,24.8Zm0-12.2a5.5,5.5,0,1,0,5.5,5.5A5.616,5.616,0,0,0,15.4,12.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M28.8,47.3a6.882,6.882,0,0,1-1.3-.2L23,45.4c-.1,0-.2-.1-.3-.2l-.7-.7V44a.52.52,0,0,1,.2-.4.6.6,0,0,1,.9,0l.6.6L28,45.8a2.2,2.2,0,0,0,.8.1,2.024,2.024,0,0,0,1.8-1.2,1.7,1.7,0,0,0,0-1.4,1.514,1.514,0,0,0-1-.9L25.5,41c-.1,0-.3-.1-.3-.2L22,36.2a.651.651,0,0,1,.2-.9c.1-.1.2-.1.4-.1a.55.55,0,0,1,.5.3L26.2,40l3.9,1.3A2.857,2.857,0,0,1,31.8,43a3.312,3.312,0,0,1,0,2.4A3.538,3.538,0,0,1,28.8,47.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M28.4,78.5a3.914,3.914,0,0,1-3.7-2.6L20.4,64.5,10.2,50.7c-.1-.1-.1-.2-.1-.4V37.9L7.5,39.6,7.3,44a3.142,3.142,0,0,1-3,3.3c-.1,0-.2.1-.3.1A3.256,3.256,0,0,1,.9,44.3v-.1l.2-6.8a3.25,3.25,0,0,1,1.1-2.5h.1l8.9-6.2c.3-.2,2.5-1.9,4.2-1.9,2.8,0,4.8,2.3,4.8,5.4v20l6.2,8,.1.1a15.059,15.059,0,0,1,1.2,1.9L32,73.6a3.666,3.666,0,0,1-.3,2.9,4.522,4.522,0,0,1-2.2,1.9C29.2,78.4,28.8,78.5,28.4,78.5ZM10.8,36.1a.367.367,0,0,1,.3.1.6.6,0,0,1,.3.6V50.2L21.5,64a.349.349,0,0,1,.1.2l4.3,11.5a2.624,2.624,0,0,0,2.5,1.7,1.949,1.949,0,0,0,.8-.1,2.555,2.555,0,0,0,1.5-1.2,2.292,2.292,0,0,0,.2-1.8L26.6,62.9a14.987,14.987,0,0,0-1-1.6l-.2-.3L19,52.8a.6.6,0,0,1-.1-.4V32.2c0-2-1.1-4.1-3.5-4.1A6.754,6.754,0,0,0,12,29.7L3.1,35.9h0a1.523,1.523,0,0,0-.5,1.4l-.2,6.9a2.034,2.034,0,0,0,1.8,1.9h.1l.2-.1.2-.1C5.5,45.5,6,45.2,6,44l.2-4.7a.55.55,0,0,1,.3-.5l3.9-2.6C10.5,36.1,10.6,36.1,10.8,36.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M.9,78.1a4.006,4.006,0,0,1-2.3-.8,3.546,3.546,0,0,1-1.4-2.5A4.019,4.019,0,0,1-2,72l6.7-7.8L9.2,53.8a.675.675,0,0,1,.6-.4.367.367,0,0,1,.3.1.63.63,0,0,1,.3.9L5.7,64.9c0,.1-.1.1-.1.2L-1,72.8a2.383,2.383,0,0,0-.5,1.8,2.358,2.358,0,0,0,.9,1.6,2.7,2.7,0,0,0,1.5.5,2.2,2.2,0,0,0,1.9-.9l7.3-8.4.3-.6L13.5,60a.675.675,0,0,1,.6-.4.367.367,0,0,1,.3.1c.2.1.3.2.3.4a.454.454,0,0,1,0,.5l-3.1,6.7a2.177,2.177,0,0,1-.5.8L3.8,76.5A3.26,3.26,0,0,1,.9,78.1Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentIconDark);
export default __webpack_public_path__ + "static/media/rent-icon-dark.3c27ed466b670f419c128b84e1395c66.svg";
export { ForwardRef as ReactComponent };